
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import templatesService from '@/services/TemplatesService'
import { Template, TemplateFilters, SortTypes } from '@/types/Templates'
import { PageRequest } from '@/types/Support'
import LoadingMask from '@/components/generic/LoadingMask.vue'

const PAGE_SIZE = 5

@Component({
  components: {
    LoadingMask
  }
})
export default class TemplateSelector extends Vue {
  Template = Template
  templates: Template[] = []
  page = 1
  total = 0
  paging = new PageRequest<TemplateFilters>(PAGE_SIZE)
  selected = new Template()
  selectionListVisible = false
  loading = false

  @Prop({ required: false })
  selectedId: number

  @Prop({ required: false })
  enabled: boolean

  @Prop({ required: false })
  pageSize: number

  @Prop({ required: false, default: 'Seleccione un template' }) // tracking, fillgrid
  placeholder: string

  @Prop({ required: false, default: () => ['enabled', 'label', 'version'] })
  sorts: Array<string>

  @Prop({ required: false, default: () => [SortTypes.DESC, SortTypes.ASC, SortTypes.DESC] })
  sortTypes: Array<SortTypes>

  mounted () {
    this.paging.size = this.pageSize || PAGE_SIZE
    this.paging.filters.enabled = this.enabled
    this.paging.filters.sort = this.sorts
    this.paging.filters.sortType = this.sortTypes
    this.loadTemplates()
  }

  @Watch('selectedId')
  watchSelectedId (value: number) {
    if (value && value !== this.selected.id) {
      let found = this.templates.find(it => it.id === value)
      if (found) {
        this.select(found)
      }
    }
  }

  loadTemplates () {
    this.loading = true
    templatesService.getTemplates(this.paging).then((pageResponse) => {
      setTimeout(() => {
        this.loading = false
        this.templates = pageResponse.content.map(it => Object.freeze(it))
        this.total = pageResponse.totalElements
        if (this.page === 1) {
          this.$emit('loaded', this.templates)
        }
      }, 120)
    })
  }

  toggleListVisible () {
    this.selectionListVisible = !this.selectionListVisible
  }

  select (template: Template) {
    this.selected = template
    this.$emit('select', template)
    this.selectionListVisible = false
  }

  getTemplateDisplayLabel (template: Template) {
    return `${template.label} [v${template.version}]`
  }

  goToPage (page: number) {
    this.page = page
    this.paging.page = page - 1
    this.loadTemplates()
  }
}
